const Widgets = [
  {
    name: 'Widget Editor',
    slug: 'widget-editor',
    data: {
      template: 'widget-editor',
    },
  },
  {
    name: 'Banner with CTA Button',
    slug: 'widgets-banner-with-cta',
    data: {
      editable: [
        {
          id: 'title',
          label: 'Title',
        },
        {
          id: 'bodyText',
          label: 'Body Text',
          type: 'textarea',
        },
        {
          id: 'ctaButtonText',
          label: 'CTA Button Text',
        },
        {
          id: 'ctaButtonUrl',
          label: 'CTA Button URL',
        },
        {
          id: 'bgColour',
          label: 'Background Colour (optional)',
        },
        {
          id: 'bgImageUrl',
          label: 'Background Image URL',
        },
        {
          id: 'useVideo',
          label: 'Use Video BG',
          type: 'boolean',
        },
        {
          id: 'vimeoId',
          label: 'Vimeo Background Video ID (e.g. 415962479)',
        },
        {
          id: 'limitWidth',
          label: 'Limit Width? (to blog article)',
          type: 'boolean',
        },
      ],
      template: 'banner-with-cta',
    },
  },
  {
    name: 'Get Quote Banner',
    slug: 'widgets-get-quote-banner',
    data: {
      editable: [
        {
          id: 'title',
          label: 'Title',
        },
        {
          id: 'bodyText',
          label: 'Body Text',
          type: 'textarea',
        },
        {
          id: 'bgColour',
          label: 'Background Colour (optional)',
        },
        {
          id: 'bgImageUrl',
          label: 'Background Image URL',
        },
        {
          id: 'useVideo',
          label: 'Use Video BG',
          type: 'boolean',
        },
        {
          id: 'vimeoId',
          label: 'Vimeo Background Video ID (e.g. 415962479)',
        },
        {
          id: 'campaignId',
          label: 'Campaign ID (leave blank if none)',
        },
        {
          id: 'limitWidth',
          label: 'Limit Width? (to blog article)',
          type: 'boolean',
        },
        {
          id: 'itmWidget',
          label: 'ITM Widget Value',
        },
        {
          id: 'itmArticle',
          label: 'ITM Article Value',
        },
        {
          id: 'itmWo',
          label: 'ITM Work Operation Value',
        },
        {
          id: 'explicitOperationIds',
          label: 'Operation Id(s)',
        },
        {
          id: 'sku',
          label: 'SKU',
        },
      ],
      template: 'banner-with-cta',
      vrmLookup: true,
    },
  },
  {
    name: 'Start Booking',
    slug: 'widgets-start-booking',
    data: {
      template: 'start-booking',
    },
  },
  {
    name: 'USP Banner',
    slug: 'widgets-usp-banner',
    data: {
      template: 'usp-banner',
    },
  },
  {
    name: 'MOT Reminder Blog',
    slug: 'widgets-mot-reminder-blog',
    data: {
      template: 'reminder-blog',
      reminderType: 'mot',
    },
  },
  {
    name: 'Service Reminder Blog',
    slug: 'widgets-service-reminder-blog',
    data: {
      template: 'reminder-blog',
      reminderType: 'service',
    },
  },
  {
    name: 'Subscriber Bar',
    slug: 'widgets-subscriber-bar',
    data: {
      template: 'reminder-blog',
      reminderType: 'subscribe',
    },
  },
  {
    name: 'Trustpilot',
    slug: 'widgets-trustpilot-widget',
    data: {
      editable: [
        {
          id: 'useMiniCarousel',
          label: 'Use Mini Carousel',
          type: 'boolean',
        },
      ],
      template: 'trustpilot-widget',
    },
  },
];

module.exports = Widgets;
